import React, { useState, useEffect, useContext, useMemo } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { collection, query, where, getDocs } from "firebase/firestore";
import { UserContext } from '../../UserContext.js';
import { getAnalytics, logEvent } from '@firebase/analytics';
import { useLocation } from 'react-router-dom';

import { db, auth } from '../../config/firebaseConfig.js';
import logo from '../../assets/logo-blue.png';
import {loadStripe} from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout
} from '@stripe/react-stripe-js';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,useNavigate
} from "react-router-dom";

const Return = () => {
    const analytics = getAnalytics();
    const location = useLocation();
    
    const [status, setStatus] = useState(null);
    const [customerEmail, setCustomerEmail] = useState('');
    const { userId, setUserId } = useContext(UserContext);
    const [user, loading, error] = useAuthState(auth);
    // const [user , setCustomerEmail] = useState('');
    let navigate = useNavigate();

    useEffect(() => {
      logEvent(analytics, 'postcheckout_visit', {
        firebase_screen: location.pathname,
        firebase_screen_class: 'firebase-routes-analytics', 
      });
    }, [location]);

    useEffect(() => {
      const getData = async () =>  {
        if(user){
          const q = query(collection(db, "users"), where("uid", "==", user?.uid));
          const querySnapshot = await getDocs(q);
          querySnapshot.forEach((doc) => {
            // const userData = doc.data();
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const sessionId = urlParams.get('session_id');
            fetch(`${process.env.REACT_APP_BACKEND_URL}/session-status?session_id=${sessionId}`, {
              method: "POST",
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                userid:doc.id, 
                accessToken:user.accessToken}),
            })
            .then((res) => res.json())
            .then((data) => {
              setStatus(data.status);
              setCustomerEmail(data.customer_email);
            });
            // console.log(user.id,userId)
          });
        }
      }
      getData()

    }, [user]);

    const goToAppClick = async () => {
        console.log("here")
    }

    if (status === 'open') {
      return (
        <Navigate to="/waitlist" />
        // <Navigate to="/chooseplan" />
      )
    }
  
    if (status === 'complete') {
      return (
        // TODO: success, send user to the app!
        <>
        <div className="choosePlan">
      
      <div class="bg-white p-8 rounded-2xl shadow-lg max-w-lg">

        <div className="welcome-container">
          <img src={logo} alt="Logo" className="welcome_logo"/>
        </div>

        
        <div className='mb-8'>
          <h2 className="text-2xl font-semibold mb-4 text-center">Welcome to SkimAI!</h2>
          <p>Thank you for your purchase. A confirmation email has been sent to <strong>{customerEmail}</strong>. You are all set to start using all the features of SkimAI.</p>
          <div style={{ height: '8px' }}></div> 
          <p>If you have any questions or need assistance, feel free to reach out to us at <a href="mailto:support@skim.page" style={{ color: '#007bff', textDecoration: 'underline' }}>support@skim.page</a>.</p>
        </div>

        <div class="flex">
          <button
            type="button" 
            className="ml-auto text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            onClick={()=> navigate('/email')}>
            Start Using SkimAI
            <svg class="rtl:rotate-180 w-3.5 h-3.5 ms-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
            {/* <section id="success">
                <p>
                    We appreciate your business! A confirmation email will be sent to {customerEmail}.
        
                    If you have any questions, please email <a href="mailto:orders@example.com">orders@example.com</a>.
                </p>
            </section>
            <div onClick={goToAppClick}> Go to app</div> */}
        </>

      )
    }else {
      return (
        <>
        <div className="choosePlan">
      
          <div class="bg-white p-8 rounded-2xl shadow-lg max-w-lg">
            <li class="flex items-center">
                <div role="status">
                    <svg aria-hidden="true" class="w-4 h-4 me-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/></svg>
                    <span class="sr-only">Loading...</span>
                </div>
                Loading ...
            </li>
          </div>
        </div>
        </>
      )
    }
  
    return null;
  }

  export default Return;